// extracted by mini-css-extract-plugin
export default {"Dropdown":"hzPzc","selector":"_mvnV","open":"_0AWY","icon":"wolxB","options":"Fw6vm","option":"boI3P"};